import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateEventItem($companyId: ID!, $id: ID!, $attributes: EventItemAttributes!) {
    updateEventItem(companyId: $companyId, id: $id, attributes: $attributes) {
      eventItem {
        id
        ...UpdatedEventItem
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedEventItem on EventItem {
    id
    eventStage { id }
    notes
    quantity
    discount
    item {
      ...on AssetType {
        id
        name
        images { id url }
      }
      ...on Package {
        id
        name
        images { id url }
      }
      ...on RowItem {
        id
        name
        images { id url }
      }
      ...on Vehicle {
        id
        name
        images { id url }
      }
    }
  }
`
